import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";

export function InventoryTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  return (
    <div className="flex border-b border-(--color-text-border)/65 font-sans shrink-0">
      <button
        type="button"
        className={cn(
          "py-3 px-5 text-sm font-bold border-b-2 transition cursor-pointer mb-[-2px]",
          activeTab === "position"
            ? "border-primary text-primary"
            : "border-transparent per-file-hint hover:text-foreground"
        )}
        onClick={() => onTabChange("position")}
      >
        {t("inventory.stockPosition")}
      </button>

      <button
        type="button"
        className={cn(
          "py-3 px-5 text-sm font-bold border-b-2 transition cursor-pointer mb-[-2px]",
          activeTab === "journal"
            ? "border-primary text-primary"
            : "border-transparent per-file-hint hover:text-foreground"
        )}
        onClick={() => onTabChange("journal")}
      >
        {t("inventory.stockJournal")}
      </button>
    </div>
  );
}
